import * as React from 'react'
import type { SVGProps } from 'react'
function Icon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      id="MS_Klimadashboard_Icons_luftqualitaet_positiv_svg__Ebene_1"
      viewBox="0 0 64.75 69.31"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <defs>
        <style>
          {
            '.MS_Klimadashboard_Icons_luftqualitaet_positiv_svg__cls-1{fill:#34c17b; stroke-width:0}'
          }
        </style>
      </defs>
      <path
        className="MS_Klimadashboard_Icons_luftqualitaet_positiv_svg__cls-1"
        d="M32.21 14.17c11.47 0 20.77 9.3 20.77 20.77s-9.3 20.77-20.77 20.77-20.77-9.3-20.77-20.77 9.3-20.77 20.77-20.77m0-2.5c-12.83 0-23.27 10.44-23.27 23.27s10.44 23.27 23.27 23.27 23.27-10.44 23.27-23.27-10.44-23.27-23.27-23.27Z"
      />
      <path
        className="MS_Klimadashboard_Icons_luftqualitaet_positiv_svg__cls-1"
        d="M28.99 45.71c-.73 0-1.38-.45-1.64-1.13-2.13-5.63-5.02-7.69-5.05-7.71a1.76 1.76 0 0 1-.45-2.43c.54-.79 1.62-1 2.41-.47.12.08 2.48 1.7 4.73 5.81 1.95-3.51 5.84-8.93 12.87-13.33a1.75 1.75 0 0 1 1.85 2.97C33.66 35.7 30.66 44.41 30.63 44.5c-.23.7-.88 1.18-1.62 1.2h-.04Z"
      />
    </svg>
  )
}
export default Icon
